module.exports = __webpack_public_path__ + "media/assets/gradeus-logo-transparent-56b6a5f9e4048a0f1ac4090a004b1a85.png";